import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Guid } from 'guid-typescript';
import { Observable, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CsProject } from '../cs-projects/state/cs-project.model';
import { CsProjectsQuery } from '../cs-projects/state/cs-projects.query';
import { CsProjectsService } from '../cs-projects/state/cs-projects.service';
import { ComponentCanDeactivate } from '../shared';
import { CsBuildupStateQuery, TotalCostsService, TotalCostsStateQuery } from './shared';

@Component({
  selector: 'app-cs-buildup',
  templateUrl: './cs-buildup.component.html',
  styleUrls: ['./cs-buildup.component.scss']
})
export class CsBuildupComponent implements OnInit, OnDestroy, ComponentCanDeactivate  {
  unsavedChangesTooltipText = 'Dieser Abschnitt enthält ungespeicherte Änderungen';
  csProject: CsProject;
  readonly projectId: Guid;
  private projectSubscription: Subscription;
  private editModeSubscription: Subscription;
  private internalIsBusy: boolean;
  private internalIsAnyInEditMode: boolean;
  private internalInitializingTotalCosts: boolean;
  private internalTotalCosts?: number;
  private totalCostsSubscription: Subscription;

  public get isBusy(): boolean {
    return this.internalIsBusy;
  }

  public get isAnyInEditMode(): boolean {
    return this.internalIsAnyInEditMode;
  }

  public get initializingTotalCosts(): boolean {
    return this.internalInitializingTotalCosts;
  }

  public get totalCosts(): number {
    return this.internalTotalCosts;
  }

  constructor(private activatedRoute: ActivatedRoute,
              private csBuildupStateQuery: CsBuildupStateQuery,
              private projectsQuery: CsProjectsQuery,
              private totalCostsStateQuery: TotalCostsStateQuery,
              private totalCostsService: TotalCostsService,
              private service: CsProjectsService,
              private http: HttpClient) {
    this.projectId = Guid.parse(this.activatedRoute.snapshot.paramMap.get('id'));
  }

  ngOnInit(): void {
    this.internalInitializingTotalCosts = true;
    this.totalCostsStateQuery
      .allTotalCostsRelevantSectionsInitialized()
      .subscribe(initialized => {
        this.internalInitializingTotalCosts = !initialized;
      });

    this.editModeSubscription = this.csBuildupStateQuery
      .isAnySectionPartInEditMode()
      // Promise.resolve()... is needed because of ExpressionChangedAfterItHasBeenCheckedError
      .subscribe(isInEditMode => Promise.resolve().then(() => this.internalIsAnyInEditMode = isInEditMode));

    this.totalCostsSubscription = this.totalCostsStateQuery
      .getProjectCosts()
      // Promise.resolve()... is needed because of ExpressionChangedAfterItHasBeenCheckedError
      .subscribe(totalCosts => Promise.resolve().then(() => this.internalTotalCosts = totalCosts));

    this.projectSubscription = this.projectsQuery
      .selectEntity(this.projectId)
      .subscribe(csProject => this.csProject = csProject);

    if (!this.projectsQuery.getEntity(this.projectId)) {
      this.service.get<CsProject[]>().subscribe(
        () => { },
        error => { });
    }
  }

  ngOnDestroy(): void {
    this.editModeSubscription.unsubscribe();
    this.projectSubscription.unsubscribe();
    this.totalCostsSubscription.unsubscribe();
    this.totalCostsService.reset();
  }

  // @HostListener allows us to also guard against browser refresh, close, etc.
  @HostListener('window:beforeunload')
  canDeactivate: () => boolean | Observable<boolean>  = () => {
    return !this.isAnyInEditMode;
  }

  createOfferDocument(): void {
    this.internalIsBusy = true;
    this.http.get(`${environment.offerApiUrl}/offers/${this.csProject.id}/pdf`, {responseType: 'blob'}).subscribe(
      offer => {
        const downloadURL = window.URL.createObjectURL(offer);
        const link = document.createElement('a');
        link.href = downloadURL;
        link.download = `Angebot - ${this.csProject.projectName}.pdf`;
        link.click(); },
      error => {
        console.error(error);
      },
      () => this.internalIsBusy = false);
  }

  // public getChargingStationSectionEntries(projectId: Guid): Observable<any> {
  //   return this.http.get<any>(`${this.projectsUrl}/${projectId}/offer`, { responseType: 'json' })
  //     .pipe(
  //       map(projectOffer => this.http.get<any>(`${this.offersUrl}/${projectOffer.id}/sections`, { responseType: 'json' })),
  //       flatMap(sections => sections),
  //       map(sections => sections.filter(section => section.offerSectionType === 'ChargingStationGroup')),
  //       map(csSections => this.http.get<any>(
  //         `${this.offersUrl}/${csSections[0].offerId}/sections/${csSections[0].id}/prductentries`,
  //         { responseType: 'json' })),
  //       flatMap(entries => entries));
  // }
}
